import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppInitializationService } from 'app/app-initialization.service';
import { Envanter } from 'app/models/envanter.model';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class EnvanterService {

    envanter: any[];
    onChanged: BehaviorSubject<any>;

    constructor(
        private _httpClient: HttpClient,
        private appConfigService: AppInitializationService,
    ) {
        this.onChanged = new BehaviorSubject({});
    }


    getEnvanter(companyId: number): Promise<Array<Envanter>> {

        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "envanters/" + companyId)
                .subscribe((response: any) => {
                    this.envanter = response;
                    this.onChanged.next(this.envanter);
                    resolve(response);
                }, reject);
        });
    }

    add(entity: Envanter): Promise<Envanter> {

        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "envanters/add", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }
    updated(entity: Envanter): Promise<Envanter> {

        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "envanters/update", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    upload(entity: FormData): Promise<File> {

        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "upload/envanter", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    delete(entity: Envanter): Promise<Envanter> {
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "envanters/delete", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }
    ImageDelete(entity: Envanter): Promise<Envanter> {
        return new Promise((resolve, reject) => {
            var form = new FormData()
            form.append('Position', 'envanter')
            form.append('Picture', entity.icon)
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "upload/delete", form)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        })
    }

}
